import React, { useEffect, useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000); // Change testimonial every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const getVisibleTestimonials = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % testimonials.length;
      visible.push(testimonials[index]);
    }
    return visible;
  };

  return (
    <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Star className="w-8 h-8 fill-[#FDB913] text-[#FDB913]" />
            <Star className="w-8 h-8 fill-[#FDB913] text-[#FDB913]" />
            <Star className="w-8 h-8 fill-[#FDB913] text-[#FDB913]" />
            <Star className="w-8 h-8 fill-[#FDB913] text-[#FDB913]" />
            <Star className="w-8 h-8 fill-[#FDB913] text-[#FDB913]" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4">What Our Customers Say</h2>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Rated 4.9/5 stars with 37+ reviews on Google
          </p>
          <p className="text-sm mt-2 text-[#FDB913] font-semibold">
            🏆 Top 1% of Canadian Businesses - 95%+ Quality Score
          </p>
        </div>

        {/* Testimonials Carousel */}
        <div className="relative">
          <div className="grid md:grid-cols-3 gap-6">
            {getVisibleTestimonials().map((testimonial) => (
              <Card 
                key={`testimonial-${testimonial.id}-${currentIndex}`}
                className="bg-white text-gray-900 border-[#FDB913]/30 hover:border-[#FDB913] transition-all duration-300 transform hover:scale-105"
              >
                <CardContent className="pt-6 pb-6">
                  <Quote className="w-10 h-10 text-[#FDB913] mb-4 opacity-50" />
                  
                  {/* Rating */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-[#FDB913] text-[#FDB913]" />
                    ))}
                  </div>

                  {/* Review Text */}
                  <p className="text-gray-700 leading-relaxed mb-6 min-h-[100px]">
                    "{testimonial.review}"
                  </p>

                  {/* Reviewer Info */}
                  <div className="border-t border-gray-200 pt-4">
                    <p className="font-bold text-gray-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-500">{testimonial.date}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Progress Indicators */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((testimonial) => (
              <button
                key={`indicator-${testimonial.id}`}
                onClick={() => setCurrentIndex(testimonials.indexOf(testimonial))}
                className={`h-2 rounded-full transition-all duration-300 ${
                  testimonials.indexOf(testimonial) === currentIndex 
                    ? 'w-8 bg-[#FDB913]' 
                    : 'w-2 bg-gray-600 hover:bg-gray-500'
                }`}
                aria-label={`Go to testimonial ${testimonials.indexOf(testimonial) + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Google Reviews Link */}
        <div className="text-center mt-12">
          <a
            href="https://www.google.com/maps/place/THE+LOKAL+WINERY"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#FDB913] hover:text-[#E5A50A] transition-colors font-semibold"
          >
            <Star className="w-5 h-5 fill-[#FDB913]" />
            Read all reviews on Google
            <span className="ml-2">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
